"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmartyStreetsInternationalProvider = exports.useSmartyStreetsInternationalClient = exports.SmartyStreetsInternationalContext = void 0;
/* eslint-disable @typescript-eslint/no-explicit-any */
var react_1 = __importStar(require("react"));
var smartystreets_javascript_sdk_1 = require("smartystreets-javascript-sdk");
/**
 * When the hook is called the SmartyStreets client must be available
 * on this context object.
 */
exports.SmartyStreetsInternationalContext = react_1.createContext(null);
/**
 * Access the SmartyStreets client directly.
 * Throw an error if client is undefined
 */
function useSmartyStreetsInternationalClient() {
    var client = react_1.useContext(exports.SmartyStreetsInternationalContext);
    if (!client) {
        throw new Error('SmartyStreets client must be set on SmartyStreetsInternationalContext');
    }
    return client;
}
exports.useSmartyStreetsInternationalClient = useSmartyStreetsInternationalClient;
/**
 * Create the SmartyStreets client
 */
function SmartyStreetsInternationalProvider(props) {
    var apiKey = props.apiKey, children = props.children;
    var client = react_1.useMemo(function () {
        var credentials = new smartystreets_javascript_sdk_1.core.SharedCredentials(apiKey);
        // eslint-disable-next-line new-cap
        var clientBuilder = new smartystreets_javascript_sdk_1.core.ClientBuilder(credentials);
        return {
            internationalStreetClient: clientBuilder.buildInternationalStreetClient(),
        };
    }, [apiKey]);
    return (react_1.default.createElement(exports.SmartyStreetsInternationalContext.Provider, { value: client }, children));
}
exports.SmartyStreetsInternationalProvider = SmartyStreetsInternationalProvider;
